/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_Builds_Noresults1Inputs */

const id_table_builds_noresults1 = /** @type {(inputs: Table_Builds_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada hasil.`)
};

const ms_table_builds_noresults1 = /** @type {(inputs: Table_Builds_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada hasil.`)
};

const da_table_builds_noresults1 = /** @type {(inputs: Table_Builds_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen resultater.`)
};

const de_table_builds_noresults1 = /** @type {(inputs: Table_Builds_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Ergebnisse.`)
};

const en_us2_table_builds_noresults1 = /** @type {(inputs: Table_Builds_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No results.`)
};

const es_es2_table_builds_noresults1 = /** @type {(inputs: Table_Builds_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin resultados.`)
};

const es_mx2_table_builds_noresults1 = /** @type {(inputs: Table_Builds_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin resultados.`)
};

const fil_table_builds_noresults1 = /** @type {(inputs: Table_Builds_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang resulta.`)
};

const fr_table_builds_noresults1 = /** @type {(inputs: Table_Builds_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun résultat.`)
};

const it_table_builds_noresults1 = /** @type {(inputs: Table_Builds_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun risultato.`)
};

const hu_table_builds_noresults1 = /** @type {(inputs: Table_Builds_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nincs találat.`)
};

const nl_table_builds_noresults1 = /** @type {(inputs: Table_Builds_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen resultaten.`)
};

const no_table_builds_noresults1 = /** @type {(inputs: Table_Builds_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen resultater.`)
};

const pl_table_builds_noresults1 = /** @type {(inputs: Table_Builds_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak wyników.`)
};

const pt_br2_table_builds_noresults1 = /** @type {(inputs: Table_Builds_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No results.`)
};

const pt_table_builds_noresults1 = /** @type {(inputs: Table_Builds_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem resultados.`)
};

const ro_table_builds_noresults1 = /** @type {(inputs: Table_Builds_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niciun rezultat.`)
};

const fi_table_builds_noresults1 = /** @type {(inputs: Table_Builds_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei tuloksia.`)
};

const sv_table_builds_noresults1 = /** @type {(inputs: Table_Builds_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga resultat.`)
};

const vi_table_builds_noresults1 = /** @type {(inputs: Table_Builds_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có kết quả.`)
};

const tr_table_builds_noresults1 = /** @type {(inputs: Table_Builds_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonuç yok.`)
};

const cs_table_builds_noresults1 = /** @type {(inputs: Table_Builds_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádné výsledky.`)
};

const bg_table_builds_noresults1 = /** @type {(inputs: Table_Builds_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Няма резултати.`)
};

const ru_table_builds_noresults1 = /** @type {(inputs: Table_Builds_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет результатов.`)
};

const uk_table_builds_noresults1 = /** @type {(inputs: Table_Builds_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Немає результатів.`)
};

const ar_table_builds_noresults1 = /** @type {(inputs: Table_Builds_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد نتائج.`)
};

const hi_table_builds_noresults1 = /** @type {(inputs: Table_Builds_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई परिणाम नहीं।`)
};

const th_table_builds_noresults1 = /** @type {(inputs: Table_Builds_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่มีผลลัพธ์`)
};

const ja_table_builds_noresults1 = /** @type {(inputs: Table_Builds_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`結果がありません。`)
};

const zh_cn2_table_builds_noresults1 = /** @type {(inputs: Table_Builds_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No results.`)
};

const zh_hant1_table_builds_noresults1 = /** @type {(inputs: Table_Builds_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No results.`)
};

const ko_table_builds_noresults1 = /** @type {(inputs: Table_Builds_Noresults1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No results.`)
};

/**
* | output |
* | --- |
* | "No results." |
*
* @param {Table_Builds_Noresults1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const table_builds_noresults1 = /** @type {((inputs?: Table_Builds_Noresults1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Builds_Noresults1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_table_builds_noresults1(inputs)
	if (locale === "ms") return ms_table_builds_noresults1(inputs)
	if (locale === "da") return da_table_builds_noresults1(inputs)
	if (locale === "de") return de_table_builds_noresults1(inputs)
	if (locale === "en-US") return en_us2_table_builds_noresults1(inputs)
	if (locale === "es-ES") return es_es2_table_builds_noresults1(inputs)
	if (locale === "es-MX") return es_mx2_table_builds_noresults1(inputs)
	if (locale === "fil") return fil_table_builds_noresults1(inputs)
	if (locale === "fr") return fr_table_builds_noresults1(inputs)
	if (locale === "it") return it_table_builds_noresults1(inputs)
	if (locale === "hu") return hu_table_builds_noresults1(inputs)
	if (locale === "nl") return nl_table_builds_noresults1(inputs)
	if (locale === "no") return no_table_builds_noresults1(inputs)
	if (locale === "pl") return pl_table_builds_noresults1(inputs)
	if (locale === "pt-BR") return pt_br2_table_builds_noresults1(inputs)
	if (locale === "pt") return pt_table_builds_noresults1(inputs)
	if (locale === "ro") return ro_table_builds_noresults1(inputs)
	if (locale === "fi") return fi_table_builds_noresults1(inputs)
	if (locale === "sv") return sv_table_builds_noresults1(inputs)
	if (locale === "vi") return vi_table_builds_noresults1(inputs)
	if (locale === "tr") return tr_table_builds_noresults1(inputs)
	if (locale === "cs") return cs_table_builds_noresults1(inputs)
	if (locale === "bg") return bg_table_builds_noresults1(inputs)
	if (locale === "ru") return ru_table_builds_noresults1(inputs)
	if (locale === "uk") return uk_table_builds_noresults1(inputs)
	if (locale === "ar") return ar_table_builds_noresults1(inputs)
	if (locale === "hi") return hi_table_builds_noresults1(inputs)
	if (locale === "th") return th_table_builds_noresults1(inputs)
	if (locale === "ja") return ja_table_builds_noresults1(inputs)
	if (locale === "zh-CN") return zh_cn2_table_builds_noresults1(inputs)
	if (locale === "zh-Hant") return zh_hant1_table_builds_noresults1(inputs)
	return ko_table_builds_noresults1(inputs)
});
export { table_builds_noresults1 as "table.builds.noResults" }